import { messageToGibberish } from "@faire/localization/core/gibberish";
import { Language } from "@faire/types-localization-api/indigofair/languages/Language";
import type { ILocaleKey } from "@faire/types-localization-api/indigofair/locale/ILocaleKey";
import type {
  IntlShape,
  MessageDescriptor,
} from "@formatjs/intl/lib/src/types";
import type {
  Options as IntlMessageFormatOptions,
  FormatXMLElementFn,
  PrimitiveType,
} from "intl-messageformat";

export const createFormatMessage = (
  localeKey: ILocaleKey | undefined,
  formatMessageFn: IntlShape["formatMessage"]
): IntlShape["formatMessage"] => {
  if (localeKey?.language === Language.STRING_ID) {
    return (descriptor: MessageDescriptor) => descriptor.id as string;
  }

  if (localeKey?.language === Language.GIBBERISH) {
    const gibberishFunction: IntlShape["formatMessage"] = function (
      descriptor: MessageDescriptor,
      values?: Record<
        string,
        PrimitiveType | FormatXMLElementFn<string, string>
      >,
      opts?: IntlMessageFormatOptions
    ): string {
      return formatMessageFn(
        {
          defaultMessage: messageToGibberish(descriptor.defaultMessage),
          id: descriptor.id,
        },
        values,
        opts
      ) as string;
    };
    return gibberishFunction;
  }

  return formatMessageFn;
};
